import qs from "qs";
import axios from "axios";
import { API_URL } from "../../../constants/Constants";

const VALIDATE_STONES_ACTION = "validate_stones_measures";
const VALIDATE_WORK_ORDER_ACTION = "validate_work_order";

/**
 * Valida que las piedras de las MOs tengan medidas y precios
 * @param {Array|Object} moDataList - Array de MOs (bulk) o objeto MO (single)
 * @returns {Promise<Object|false>} Resultado de la validación o false si hay error
 */
export const validateStonesMeasures = async (moDataList) => {
  const moList = Array.isArray(moDataList) ? moDataList : [moDataList];
  
  const moStonesData = {};
  
  moList.forEach((moData) => {
    if (moData.tiemposProceso?.PIEDRAS) {
      const piedrasCodes = Object.keys(moData.tiemposProceso.PIEDRAS);
      if (piedrasCodes.length > 0) {
        moStonesData[moData.mo] = piedrasCodes;
      }
    }
  });

  // Cambiar formato: usar "screen" y "action" en lugar de "query_type"
  const queryData = {
    screen: "parts_movements",        // En lugar de query_type: SCREEN_IDS.PARTS_MOVEMENTS
    action: VALIDATE_STONES_ACTION,   // Se mantiene igual
    moStonesData: JSON.stringify(moStonesData)
  };

  try {
    // Cambiar URL a la nueva API
    const response = await axios.post(API_URL, qs.stringify(queryData));

    let responseData = response.data;

    if (typeof responseData === 'string' && responseData.includes('{')) {
      try {
        const jsonStart = responseData.indexOf('{');
        const jsonString = responseData.substring(jsonStart);
        responseData = JSON.parse(jsonString);
      } catch (parseError) {
        console.error("Error al parsear JSON de la respuesta:", parseError);
        return false;
      }
    }

    if (responseData.status === "ok" || responseData.status === "success") {
      return responseData.data || responseData;
    } else {
      console.error("Error en validación:", responseData.message);
      return false;
    }
  } catch (error) {
    console.error("Error al validar medidas de piedras:", error);
    return false;
  }
};

/**
 * Valida si las MOs tienen ya orden de trabajo
 * @param {Array|Object} moDataList - Array de MOs (bulk) o objeto MO (single)
 * @returns {Promise<Object|false>} Resultado de la validación o false si hay error
 */
export const validateWorkOrder = async (moDataList) => {
  const moList = Array.isArray(moDataList) ? moDataList : [moDataList];
  
  // Extraer solo los números de MO
  const moNumbers = moList.map((moData) => moData.mo);

  // Cambiar formato: usar "screen" y "action" en lugar de "query_type"
  const queryData = {
    screen: "parts_movements",        // En lugar de query_type: SCREEN_IDS.PARTS_MOVEMENTS
    action: VALIDATE_WORK_ORDER_ACTION,   // Se mantiene igual
    moList: JSON.stringify(moNumbers)
  };

  try {
    // Cambiar URL a la nueva API
    const response = await axios.post(API_URL, qs.stringify(queryData));

    let responseData = response.data;

    if (typeof responseData === 'string' && responseData.includes('{')) {
      try {
        const jsonStart = responseData.indexOf('{');
        const jsonString = responseData.substring(jsonStart);
        responseData = JSON.parse(jsonString);
      } catch (parseError) {
        console.error("Error al parsear JSON de la respuesta:", parseError);
        return false;
      }
    }

    if (responseData.status === "ok" || responseData.status === "success") {
      return responseData.data || responseData;
    } else {
      console.error("Error en validación de orden de trabajo:", responseData.message);
      return false;
    }
  } catch (error) {
    console.error("Error al validar orden de trabajo:", error);
    return false;
  }
};